import { Autoescola } from "../models/Autoescola";
import { Get, ServiceBase } from "./ServiceBase";

const urlBase = `${ ServiceBase.instance.defaults.baseURL }`;

export const GetAutoescolaFinanceiroById = (autoescolaId: number) => {
  return Get<Autoescola>(urlBase + 'Autoescola/' + autoescolaId)
}